import RangeSlider from "./range";

class Calculator2 {
	constructor(container) {
		this.container = document.querySelector(container);
		if (!this.container) return;
		this.btn = this.container.querySelector('.btn-calculation');
		this.inputs = this.container.querySelectorAll('[data-calculate-input]');
		this.inputNumber = this.container?.querySelector('input[type="number"]');
		this.deliveryType = this.container?.querySelectorAll('input[name="radio-delivery"]');
		this.distanceArea = this.container?.querySelector('.distance-area');
		this.distance = this.container?.querySelector('[data-calculate-input="distance-price"]');
		this.result = this.container.querySelector('[data-calculate-result]');
		this.linkModal = this.container?.querySelector('.link-modal');
		this.deliveryPrice = 0;

		this.btn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!this.errorsInputNumber('click')) return;
			this.getDistancePrice();
			this.calculate();
			this.showRequestBtn();
		});

		this.errorsInputNumber();
		this.deliveryOnChange();
		this.actionOnChangeInput();
	}

	isDelivery() {
		return this.isDeliveryType('delivery');
	}

	isPickup() {
		return this.isDeliveryType('pickup');
	}

	isDeliveryType(type) {
		let bool = false;
		this.deliveryType.forEach(el => {
			if (el.checked && type === el.value) {
				bool = true
			}
		});

		return bool;
	}

	getUserValue() {
		return Number(this.inputNumber.value)
	}

	filterPrice(price) {
		return new Intl.NumberFormat('ru-RU').format(price);
	}

	deliveryOnChange() {
		this.deliveryType.forEach(el => {
			el.onchange = () => {
				if (this.isDelivery()) {
					this.removeError(this.distanceArea, 'disabled');
				}

				if (this.isPickup()) {
					this.addError(this.distanceArea, 'disabled');
				}

				this.hiddenRequestBtn();
			}
		})
	}

	getDistancePrice() {
		if (this.isDelivery()) {
			this.deliveryPrice = Number(this.distance.value);
		}
		if (this.isPickup()) {
			this.deliveryPrice = 0;
		}
	}

	addError(el, className) {
		el.classList.add(className);
	}

	removeError(el, className) {
		el.classList.remove(className);
	}

	hiddenRequestBtn() {
		this.linkModal.classList.remove('d-block');
		this.linkModal.classList.add('d-none');
	}

	showRequestBtn() {
		this.linkModal.classList.remove('d-none');
		this.linkModal.classList.add('d-block');
	}

	actionOnChangeInput() {
		this.inputs.forEach((el) => {
			el.onchange = () => {
				this.hiddenRequestBtn();
			}
		})
	}

	errorsInputNumber(event) {
		const {inputNumber: el} = this;
		let isValue = false;

		if (event === 'click') {
			if (!el.value && !el.length) {
				this.addError(el, 'error');
				isValue = false
			} else {
				this.removeError(el, 'error');
				isValue = true;
			}

			return isValue;
		}


		el.oninput = () => {
			!!this.inputNumber.value && Math.abs(this.inputNumber.value) >= 0
				? Math.abs(this.inputNumber.value)
				: this.inputNumber.value = null;
			this.removeError(el);
			this.hiddenRequestBtn();
		}
	}

	generateAttribute(from, attr, to, value = []) {
		from.forEach((el, index) => {
			let name = el.getAttribute(`${attr}`);
			if (name !== '') {
				to.setAttribute(`data-${name}`, `${value[index]}`);
			}
		});
	}

	calculate() {
	};
}

class Asphalt extends Calculator2 {
	constructor(container) {
		super(container);
		this.rate = this.container?.querySelector('[data-calculate-rate]');
		this.type = this.container?.querySelector('[data-calculate-input="type"]');
		this.options = this.type?.querySelectorAll('option');
		this.centimeter = new RangeSlider('[data-range-container]', {
			value: 1,
			min: 1,
			max: 30,
			step: 0.5,
		});
	}

	getWeight() {
		let option = this.type.options[this.type.selectedIndex];
		this.optionText = option.textContent;
		return option.dataset.weight;
	}

	calculateRate() {
		this.square = this.getUserValue();
		const {rate, square} = this;
		let centimeter = this.centimeter.getValue();
		let weight = this.getWeight();
		let result = square * weight * centimeter / 1000;
		if (result < 1) {
			if (this.isDelivery()) {
				[...this.deliveryType].filter(el => !el.checked)[0].checked = true;
				this.addError(this.distanceArea, 'disabled');
			}
			result = square * weight * centimeter;
			const sum = new Intl.NumberFormat('ru-RU').format(result);
			rate.innerHTML = sum + ' кг';
			this.rateResultModal = sum + ' кг';
			this.rateResult = result / 1000;
		} else {
			const sum = new Intl.NumberFormat('ru-RU').format(result);
			rate.innerHTML = sum + ' ' + getWordForm(sum, ['тонна', 'тонны', 'тонн']);
			this.rateResultModal = sum + ' ' + getWordForm(sum, ['тонна', 'тонны', 'тонн']);
			this.rateResult = result;
		}
	}

	calculatePrice() {
		if (this.isDelivery()) {
			this.priceResult = Math.round(this.rateResult * this.type.value + this.deliveryPrice * this.rateResult);
			const sum = new Intl.NumberFormat('ru-RU').format(this.priceResult);
			this.result.innerHTML = `${sum} ₽`;
		}

		if (this.isPickup()) {
			this.priceResult = Math.round(this.rateResult * this.type.value);
			const sum = new Intl.NumberFormat('ru-RU').format(this.priceResult);
			this.result.innerHTML = `${sum} ₽`;
		}
	}

	getResultInModal() {
		const value = [
			this.filterPrice(this.square) + ' м²',
			this.optionText,
			this.deliveryPrice,
			this.centimeter.getValue() + ' см',
		];

		this.generateAttribute(
			this.inputs,
			'data-calculate-input',
			this.linkModal,
			value
		);

		this.linkModal.setAttribute('data-price', `${this.filterPrice(this.priceResult)} ₽`);
		this.linkModal.setAttribute('data-rate', `${this.rateResultModal}`);

		if (this.isDelivery()) {
			this.linkModal.setAttribute('data-distance-price', `${this.deliveryPrice} ₽`);
			this.linkModal.setAttribute('data-delivery', 'delivery');
		}
		if (this.isPickup()) {
			this.linkModal.setAttribute('data-delivery', 'pickup');
		}
	}

	modifyModal() {
		let modalId = this.linkModal.href.substring(this.linkModal.href.indexOf('#') + 1);
		let modal = document.getElementById(modalId);

		[...modal.querySelectorAll('.automobile-container, .address-container')]
			.forEach((el) => {
				let delivery = el.dataset.dtype;
				el.classList.add('d-none');
				el.querySelector('input').required = false;

				if (
					(delivery === 'delivery' && this.isDelivery())
					|| delivery === 'pickup' && this.isPickup()
				) {
					el.classList.remove('d-none');
					el.querySelector('input').required = true;
				}
			});
	}

	calculate() {
		super.calculate();
		this.calculateRate();
		this.calculatePrice();
		this.getResultInModal();
		this.modifyModal();
	}
}

new Asphalt('#form-calculator-asphalt');

class Concrete extends Calculator2 {
	constructor(container) {
		super(container);
		this.type = this.container?.querySelector('[data-calculate-input="type"]');
		this.volume = this.container?.querySelector('[data-calculate-input="volume"]');
		this.options = this.type?.querySelectorAll('option');
	}

	getPrice() {
		let option = this.type.options[this.type.selectedIndex];
		this.optionText = option.textContent;
		return Number(option.getAttribute('value'));
	}

	getResultInLink() {
		const value = [
			`${this.filterPrice(this.volume.value)} м³`,
			this.optionText,
			this.deliveryPrice + '₽',
		];

		this.generateAttribute(
			this.inputs,
			'data-calculate-input',
			this.linkModal,
			value
		);

		this.linkModal.setAttribute('data-price', `${this.filterPrice(this.priceResult)} ₽`);

		if (this.isDelivery()) {
			this.linkModal.setAttribute('data-distance-price', `${this.deliveryPrice} ₽`);
			this.linkModal.setAttribute('data-delivery', 'delivery');
		}
		if (this.isPickup()) {
			this.linkModal.setAttribute('data-delivery', 'pickup');
		}
	}

	calculatePrice() {
		this.priceBeton = this.getPrice();
		let val = Number(this.volume.value);

		if (this.isDelivery()) {
			this.priceResult = Math.round((this.deliveryPrice * val) + (this.priceBeton * val));
			const sum = new Intl.NumberFormat('ru-RU').format(this.priceResult);
			this.result.innerHTML = `${sum} ₽`;
		}

		if (this.isPickup()) {
			this.priceResult = Math.round(this.priceBeton * val);
			const sum = new Intl.NumberFormat('ru-RU').format(this.priceResult);
			this.result.innerHTML = `${sum} ₽`;
		}
	}

	calculate() {
		super.calculate();
		this.calculatePrice();
		this.getResultInLink();
	}
}

new Concrete('#form-calculator-beton');
